(ns manage.adset-integration-meta-settings.view
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["react-hook-form" :as rhf]
            [cljs-bean.core :refer [->clj]]
            [clojure.set :as set]
            [clojure.string :as str]
            [common.form :as form]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-query]]
            [common.resource.query.social-settings :as social-settings]
            [common.util :refer [spread-obj]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.meta-alerts :refer [meta-connection-alert]]
            [manage.adset-decision-tree-page.view.common :refer [id-input]]
            [manage.adset-integration-meta-settings.db :as db]
            [manage.adset.hooks :as ah]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- tiktok-identities-options [^js data]
  (map #(set/rename-keys % {:display-name :description})
       (->clj data)))

(defn- tiktok-campaign-options [^js data]
  (map #(set/rename-keys % {:name :description})
       (->clj data)))

(defui tiktok-settings-form [{:keys [control account-disabled]}]
  (let [{:keys [advertiser-id adset-id]} (use-subscribe [:url-context])
        {:keys [data isFetching]} (use-query (social-settings/tiktok-accounts-query advertiser-id))
        tiktok-account-id (rhf/useWatch #js {:name "tiktok-account-id" :control control})
        {identity-data :data
         identity-is-fetching :isFetching} (use-query (spread-obj (social-settings/tiktok-identities-query advertiser-id adset-id tiktok-account-id)
                                                                  #js {:select tiktok-identities-options}))
        {campaigns-data :data
         campaigns-is-fetching :isFetching} (use-query (spread-obj (social-settings/tiktok-campaigns-query advertiser-id adset-id tiktok-account-id)
                                                                   #js {:select tiktok-campaign-options}))]

    ($ Stack {:spacing 2}
       ($ Stack {:spacing 1}
          ($ Typography {:variant "h3" :color "text.subtle"} "TikTok Configuration")
          ($ Typography "These settings are required to connect with Tiktok Ads manager."))

       ($ id-input {:name "tiktok-account-id"
                    :label "TikTok Account Id"
                    :required true
                    :loading isFetching
                    :control control
                    :disabled account-disabled
                    :ids-with-description data})

       (when (seq tiktok-account-id)
         ($ id-input {:name "tiktok-identity-id"
                      :label "TikTok Identity Id"
                      :required true
                      :loading identity-is-fetching
                      :control control
                      :ids-with-description identity-data}))

       (when (seq tiktok-account-id)
         ($ id-input {:name "tiktok-campaign-id"
                      :label "TikTok Campaign Id"
                      :loading campaigns-is-fetching
                      :control control
                      :ids-with-description campaigns-data}))

       ($ form-field {:label "Activation"}
          ($ Tooltip {:placement :bottom-start
                      :title "This determines whether the Activation Rows are enabled by default when the Decision Tree is published."}
             ($ Box
                ($ form/checkbox {:label "Auto enable activation rows for this adset?"
                                  :name "auto-enable"
                                  :control control})))))))

(defui meta-settings-form [{:keys [control account-disabled]}]
  (let [{:keys [advertiser-id adset-id]} (use-subscribe [:url-context])

        {social-settings :data social-settings-fetching :isFetching}
        (use-query (social-settings/social-settings-query advertiser-id))

        meta-ad-account-id (rhf/useWatch #js {:name "facebook-ad-account-id"
                                              :control control})

        {{{:keys [meta-pages meta-instagram-users]} :data} :data
         adset-settings-fetching :isFetching}
        (use-query (social-settings/adset-meta-settings-query
                    advertiser-id adset-id (not-empty meta-ad-account-id)))

        {campaigns-data :data
         campaigns-is-fetching :isFetching}
        (use-query (social-settings/fetch-meta-campaigns-query
                    {:advertiser-id advertiser-id
                     :adset-id adset-id
                     :meta-ad-account-id meta-ad-account-id}))

        adset-settings-no-options-text (when (str/blank? meta-ad-account-id)
                                         "Please select Meta AD Account Id first")]
    ($ Stack {:spacing 2}
       (if (and (not social-settings-fetching)
                (empty? social-settings))
         ($ meta-connection-alert)
         ($ :<>
            ($ Stack {:spacing 1}
               ($ Typography {:variant "h3" :color "text.subtle"} "Meta Configuration")
               ($ Typography "These settings are required to connect with Meta Ads manager."))

            ($ id-input {:name "facebook-ad-account-id"
                         :label "Meta AD Account Id"
                         :required true
                         :loading social-settings-fetching
                         :control control
                         :disabled account-disabled
                         :ids-with-description social-settings})
            (when (seq meta-ad-account-id)
              ($ :<>
                 ($ id-input {:name "facebook-page-id"
                              :label "Facebook Page Id"
                              :required true
                              :control control
                              :no-options-text adset-settings-no-options-text
                              :loading adset-settings-fetching
                              :ids-with-description (map #(set/rename-keys % {:name :description})
                                                         meta-pages)})
                 ($ id-input {:name "instagram-user-id"
                              :label "Instagram User Id"
                              :required false
                              :control control
                              :no-options-text adset-settings-no-options-text
                              :loading adset-settings-fetching
                              :ids-with-description (map #(set/rename-keys % {:username :description})
                                                         meta-instagram-users)})
                 ($ id-input {:name "facebook-campaign-id"
                              :label "Meta Campaign Id"
                              :required false
                              :control control
                              :no-options-text adset-settings-no-options-text
                              :loading campaigns-is-fetching
                              :ids-with-description campaigns-data})))))
       ($ form-field {:label "Activation"}
          ($ Tooltip {:placement :bottom-start
                      :title "This determines whether the Activation Rows are enabled by default when the Decision Tree is published."}
             ($ Box
                ($ form/checkbox {:label "Auto enable activation rows for this adset?"
                                  :name "auto-enable"
                                  :control control})))))))

(defui settings [{:keys [publish-mode wrapper-component width account-disabled] :as props}]
  (let [channel (ah/use-channel)
        {:keys [on-submit] :as form-control} (db/use-form-control
                                              (merge props {:channel (name channel)}))]
    ($ wrapper-component
       {:title "Platform settings"
        :footer ($ Stack {:direction "row"
                          :spacing 1
                          :justifyContent "flex-end"}
                   ($ Button
                      {:disabled (boolean publish-mode)
                       :onClick #(do (rf/dispatch [:modal/close])
                                     (rf/dispatch [:ocp/close]))}
                      "Close")
                   ($ Button
                      {:variant "contained"
                       :onClick on-submit
                       :data-testid "adset-meta-settings-submit"}
                      (if publish-mode
                        "Save & Publish"
                        "Save")))}
       ($ Box {:sx #js {:width width}}
          (case channel
            "meta" ($ meta-settings-form (assoc form-control :account-disabled account-disabled))
            "tiktok" ($ tiktok-settings-form (assoc form-control :account-disabled account-disabled)))))))

(defmodal settings-modal :adset-integration-settings/modal-edit [props]
  ($ settings (assoc props
                     :wrapper-component modal-v2
                     :width 612)))

(defocp settings-ocp :adset-integration-settings/ocp-edit {:width "30%"} [props]
  ($ settings (assoc props :wrapper-component ocp)))
